import * as React from "react";
import {connect} from "react-redux";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import User from "../../../model/user/User";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import RemovableList from "../../../hiberUiKit/src/molecules/RemovableList/RemovableList";
import {RootState} from "../../../store/reducer/root/RootState";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import SearchDropDown from "../../../hiberUiKit/src/molecules/SearchDropDown/SearchDropDown";
import * as _ from "underscore";

interface ComponentProps {
	/**
	 * Watchers.
	 */
	watchers: User[]
	/**
	 * Update watchers action.
	 * @param {string} leadId
	 * @param {string[]} watchers
	 */
	onUpdateWatchers: (watchers: string[]) => void;
}

interface ReduxProps {
	/**
	 * All organisation users.
	 */
	users: User[]
}

interface IState {
	dropDownVisible: boolean;
}

type Props = ComponentProps & ReduxProps

class Watchers extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {dropDownVisible: false};
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.onRemove = this.onRemove.bind(this);
	}

	render() {
		const users = _.difference(this.props.users, this.props.watchers);
		return (
			<InfoModule icon={Icon.Watch} title={"WATCHERS"} actionIcon={Icon.Add} onActionIconClick={this.toggleDropdown}>
				{this.state.dropDownVisible &&
				<DropDownWrapper onOutsideClick={() => {this.setState({dropDownVisible: false})}}>
					<SearchDropDown items={users}
									onChange={this.onSelect}
									itemToLabel={(user: User) => user.getDisplayName()}
									itemToId={(user: User) => user.id}
									searchInputIcon={Icon.User}/>
				</DropDownWrapper>
				}
				{

					this.props.watchers.length ?
						<RemovableList items={this.props.watchers}
									   itemRowRenderer={(item: User) => item.getDisplayName(true)}
									   onRemove={this.onRemove}/> :
						<span className="t-body">No watchers</span>
				}
			</InfoModule>
		);
	}

	toggleDropdown() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	onSelect(user: User) {
		this.toggleDropdown();
		const updatedWatchers = this.props.watchers.map(w => w.id).concat(user.id);
		this.props.onUpdateWatchers(updatedWatchers);
	}

	onRemove(user: User) {
		const updatedWatchers = this.props.watchers.filter(w => w.id != user.id).map(u => u.id);
		this.props.onUpdateWatchers(updatedWatchers);
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	return {
		users: state.user.users.getOrElse([]).filter(u => !u.disabled && u.canBeWatcher())
	}
}

export default connect<ReduxProps, null, ComponentProps>(mapStateToProps, null)(Watchers)